import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** Only full ADMINs may view. Redirects everyone else to /chat. */
  adminOnly?: boolean;
  /**
   * USER_ADMINs and ADMINs may view. TECH users are redirected to /chat.
   * Used for the allowed-domains and user-management pages.
   */
  userAdminOnly?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  adminOnly = false,
  userAdminOnly = false,
}) => {
  const { user, loading, isAdmin, canManageUsers } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="text-center">
          <div className="loading-spinner mx-auto mb-4" />
          <p className="text-gray-600 dark:text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (adminOnly && !isAdmin()) {
    return <Navigate to="/chat" replace />;
  }

  if (userAdminOnly && !canManageUsers()) {
    return <Navigate to="/chat" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
